// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2PKDH","title":"ClientInsurance_title__3IY5a","itemText":"ClientInsurance_itemText__1LLMU"};